import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { CommonService } from '../Model/Common/common.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../Util/Session/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { UserRightService } from '../Model/UserRight/user-right.service';

@Component({
  selector: 'app-separation-approval-detail',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule],
  templateUrl: './separation-approval-detail.component.html',
  styleUrl: './separation-approval-detail.component.scss'
})
export class SeparationApprovalDetailComponent {

  isDisabled: boolean = false;
  isSuper: boolean = false;
  isApprovalLavel = true;
  Trackings = [];
  TrackingsUser = [];
  GetID = 1;
  user = {} as any;

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null,
    EmpMasterId: null,
    EmpMappingId: 0,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterId: null,
    ShiftTitle: null,
    RequestedLastWorkingDate: null,
    Time: null,
    PunchType: null,
    SeparationReason: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
    SeparationRequestDate: null,
    CalculatedLastWorkingDate: null,
    EmployeeRemark: null,
  };

  Filter = {
    ModuleMasterId: 19,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    TransactionId: 0,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    public common: CommonService,
    protected tooltip: TooltipService,
    private session: SessionService,
    private router: Router,
    private approvalMatrix: ApprovalMatrixService,
    private modalService: NgbModal,
    private toast: ToastService,
    private userright: UserRightService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    // this.common.getPageRights()
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      this.ESS_GetUserRole();
    } 
    // else if (this.GetID == 2) {
    //   this.LoadRegularizationMaster();
    // }
  }

  removeError() {
    this.Filter.isShowError = false;
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/resignationapproval/']);
      } 
      // else if (this.user.UserType == 'E') {
      //   this.router.navigate(['/request/regularization/approval/']);
      // }
    } else if (this.GetID == 2) {
      this.router.navigate(['/request/regularization']);
    }
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
      modalRef.result.then((result: any) => {
        if (result) {
          this.isDisabled = true;
          //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
          this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
            next: (response) => {
              if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.router.navigate(['/todo/resignationapproval/']);
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      }).catch(() => { });
    } else {
      this.Filter.isShowError = true;
      this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
    }
  }

  SaveRegularizationAttendance() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        // this.regularization.SaveRegularizationAttendance({ SelectType: 'WITHDRAWN', RegularizationAttendanceID: this.Filter.WebESSApprovalRequestTrackingId }).subscribe({
        //   next: (response) => {
        //     if (response.Error_Code == '697') {
        //       const modalRef = this.modalService.open(AlertSuccessComponent, {
        //         size: 'md',
        //         backdrop: 'static',
        //         centered: true,
        //         windowClass: 'confirmation-modal'
        //       });
        //       modalRef.componentInstance.Message = response.Error_Message;
        //       modalRef.result.then((result: any) => {
        //         if (result) {
        //           this.Cancel();
        //         }
        //       });
        //     } else {
        //       const modalRef = this.modalService.open(AlertWarningComponent, {
        //         size: 'md',
        //         backdrop: 'static',
        //         centered: true,
        //         windowClass: 'confirmation-modal'
        //       });
        //       modalRef.componentInstance.Message = response.Error_Message;
        //       modalRef.result.then((result: any) => { });
        //     }
        //     this.isDisabled = false;
        //   },
        //   complete: () => { },
        //   error: (error) => {
        //     this.isDisabled = false;
        //   },
        // });
      }
    });
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 19) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }


}